import Platform from "./platform"
import axios from 'axios'
import {AES, enc, mode, pad} from 'crypto-js'
import {initDebug} from "../utils/commons"

/**
 * 卓云APP
 */
class PlatformZhuoyun extends Platform {
    init() {
        initDebug()

        return new Promise((resolve, reject) => {
            try {
                const key = enc.Latin1.parse('huatech!@#huatec'),
                    userInfo = JSON.parse(window.nativePageListener.getUserInfo()),
                    appAgent = {
                        'code': userInfo['code'],
                        'username': userInfo['username'],
                        'access_token': userInfo['access_token'],
                        'host_app': 'ZHUOYUN'
                    }

                const encrypted = AES.encrypt(JSON.stringify(appAgent), key, {
                    iv: key,
                    mode: mode.CBC,
                    padding: pad.ZeroPadding
                })
                axios.defaults.headers.common['app-agent'] = encodeURIComponent(encrypted.toString())
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    }
}
export default PlatformZhuoyun